<template>
  <div class="container">
    <!-- ヘッダ -->
    <AdminOrderCustomFieldHeader />

    <!-- 支店間の共有設定 -->
    <AdminOrderCustomFieldConfigSource
      :source-client-group-id.sync="sourceClientGroupId"
      :is-set-config-source.sync="isSetConfigSource"
      @updateConfigSource="updateConfigSource"
    />

    <!-- 自由項目 -->
    <AdminOrderCustomFieldConfig
      :custom-fields="customFields"
      :is-set-config-source="isSetConfigSource"
      @updateCustomFields="updateCustomFields"
      @showAddItemDialog="showAddItemDialog"
    />

    <!-- 本数選択用のモーダル -->
    <AdminOrderCustomFieldAddItemDialog
      :is-show-add-item-dialog.sync="isShowAddItemDialog"
      @addCustomFieldItem="addCustomFieldItem"
      @closeAddItemDialog="closeAddItemDialog"
    />
  </div>
</template>

<script>
import _ from "lodash";
import AdminOrderCustomFieldHeader from "@/components/Admin/OrderCustomField/Header.vue";
import AdminOrderCustomFieldConfig from "@/components/Admin/OrderCustomField/Config.vue";
import AdminOrderCustomFieldConfigSource from "@/components/Admin/OrderCustomField/ConfigSource.vue";
import AdminOrderCustomFieldAddItemDialog from "@/components/Admin/OrderCustomField/AddItemDialog.vue";
import { apiErrorHandler } from "@/services/apiErrorHandler";
import OrderUsecase from "@/usecases/order.usecase";

const CUSTOM_FIELD_ITEM = {
  customFieldNumber: -1,
  type: "TEXT",
  name: "",
  listItems: [],
  defaultValue: null,
  enabled: true,
  required: false,
  order: 0,
};

const MAXIMUM_NUMBER_OF_ITEMS = 20;

export default {
  components: {
    AdminOrderCustomFieldHeader,
    AdminOrderCustomFieldConfig,
    AdminOrderCustomFieldConfigSource,
    AdminOrderCustomFieldAddItemDialog,
  },
  data () {
    return {
      loadingView: {},
      customFields: [],
      clientGroupId: "",
      sourceClientGroupId: "",
      isSetConfigSource: false,
      isShowAddItemDialog: false,
    };
  },
  created () {
  },
  mounted () {
    this.fetch();
  },
  methods: {
    /**
     * [fetch description]
     */
    async fetch () {
      this.loadingView = this.$loading();

      try {
        const res1 = await this.fetchOrderCustomFieldConfigSource();
        const res2 = await this.fetchOrderCustomFieldConfig();

        this.setConfigSource(res1);
        this.setCustomFields(res2);
      } catch (err) {
        apiErrorHandler(this, err);
      } finally {
        this.loadingView.close();
      }
    },

    /**
     * [updateConfigSource description]
     * @param   {[type]}  sourceClientGroupId  [sourceClientGroupId description]
     */
    async updateConfigSource (sourceClientGroupId) {
      this.loadingView = this.$loading();

      try {
        const res1 = await this.updateOrderCustomFieldConfigSource(sourceClientGroupId);
        const res2 = await this.fetchOrderCustomFieldConfig();

        this.setConfigSource(res1);
        this.setCustomFields(res2);
      } catch (err) {
        apiErrorHandler(this, err);
      } finally {
        this.loadingView.close();
      }
    },

    /**
     * [updateCustomFields description]
     */
    async updateCustomFields () {
      const check = this.validateCustomFields();

      if (!check.isValid) {
        check.notifies.forEach(notify => {
          _.defer(() => {
            this.$notify.warning({
              title: notify.title,
              duration: 5000,
            });
          });
        });

        return;
      }

      this.loadingView = this.$loading();

      try {
        await this.updateOrderCustomFieldConfig();
      } catch (err) {
        apiErrorHandler(this, err);
      } finally {
        this.loadingView.close();
      }
    },

    validateCustomFields () {
      const { customFields } = this;
      const check = {
        isValid: true,
        notifies: [],
      };

      const noLabelItem = customFields.find(customField => customField.name === "");
      const noListItem = customFields.find(customField => customField.type === "TEXT_LIST" && customField.listItems.length === 0);

      if (noLabelItem) {
        check.isValid = false;
        check.notifies.push({
          title: "項目名が入力されていない自由項目があります",
          message: "",
        });
      }

      if (noListItem) {
        check.isValid = false;
        check.notifies.push({
          title: "リストアイテムの登録がされていない自由項目があります",
          message: "",
        });
      }

      return check;
    },

    /**
     * [fetchOrderCustomFieldConfig description]
     * @return  {[type]}  [return description]
     */
    async fetchOrderCustomFieldConfig () {
      const options = this.fetchOrderCustomFieldOptions();
      const res = await orderUsecase.getOrderCustomFieldConfig(options);

      return res;
    },

    /**
     * [fetchOrderCustomFieldConfig description]
     * @return  {[type]}  [return description]
     */
    async updateOrderCustomFieldConfig () {
      const options = this.fetchOrderCustomFieldOptions();
      const itemSettings = this.fetchItemSettings();
      options.input = {
        itemSettings,
      };
      const res = await orderUsecase.updateOrderCustomFieldConfig(options);

      return res;
    },

    fetchItemSettings () {
      const { customFields } = this;

      customFields.forEach((customField, index) => {
        customField.order = index + 1;
      });

      return customFields;
    },

    /**
     * [setCustomFields description]
     * @param   {[type]}  res  [res description]
     * @return  {[type]}       [return description]
     */
    setCustomFields (res) {
      this.customFields = [];

      if (!res.data) {
        return;
      }

      this.customFields = res.data.orderCustomFieldConfig.itemSettings;
    },

    /**
     * [addCustomFieldItem description]
     * @param   {[type]}  type  [type description]
     */
    addCustomFieldItem (type) {
      const { customFields } = this;
      const item = _.cloneDeep(CUSTOM_FIELD_ITEM);

      // 1~20 までの customFieldNumber の欠番を探す
      [...Array(MAXIMUM_NUMBER_OF_ITEMS)].map((_, i) => {
        const isRegistered = customFields.find((_item) => _item.customFieldNumber === i + 1);

        if (
          !isRegistered &&
          item.customFieldNumber < 0
        ) {
          item.customFieldNumber = i + 1;
          item.type = type;
        }
      });

      if (item.customFieldNumber > 0) {
        customFields.push(item);
      }
    },

    /**
     * [fetchOrderCustomFieldConfigSource description]
     * @return  {[type]}  [return description]
     */
    async fetchOrderCustomFieldConfigSource () {
      const options = this.fetchOrderCustomFieldOptions();
      const res = await orderUsecase.getOrderCustomFieldConfigSource(options);

      return res;
    },

    /**
     * [updateOrderCustomFieldConfigSource description]
     * @param   {[type]}  sourceClientGroupId  [sourceClientGroupId description]
     * @return  {[type]}                       [return description]
     */
    async updateOrderCustomFieldConfigSource (sourceClientGroupId) {
      const options = this.fetchOrderCustomFieldOptions();
      options.sourceClientGroupId = sourceClientGroupId;

      const res = await orderUsecase.updateOrderCustomFieldConfigSource(options);

      return res;
    },

    /**
     * [setSourceClientGroupId description]
     * @param   {[type]}  res  [res description]
     * @return  {[type]}       [return description]
     */
    setConfigSource (res) {
      if (!res.data) {
        return;
      }

      this.sourceClientGroupId = res.data.orderCustomFieldConfigSource || res.data.orderCustomFieldConfigSourceUpdate || "";
      this.isSetConfigSource = this.sourceClientGroupId !== "";
    },

    /**
     * [fetchOrderCustomFieldOptions description]
     * @return  {[type]}  [return description]
     */
    fetchOrderCustomFieldOptions () {
      const options = {};
      const { params } = this.$route;

      options.clientGroupId = params.clientID;

      return options;
    },

    /**
     * [showAddItemDialog description]
     */
    showAddItemDialog () {
      this.isShowAddItemDialog = true;
    },

    /**
     * [closeAddItemDialog description]
     */
    closeAddItemDialog () {
      this.isShowAddItemDialog = false;
    },
  },
};

const orderUsecase = new OrderUsecase();
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.container {
  position: relative;
  padding-bottom: 1px;
}
</style>
